import React, { useContext } from "react";
import { useSelector } from "react-redux";
import { State } from "../../redux/store";
import { FaDownload, FaEdit } from "react-icons/fa";
import { DiplomInterface, ShowDiplomsContext } from "./types";
import { MdRemoveCircle } from "react-icons/md";
import { formatDate } from "../../functions/functions";
import { hostName } from "../../requestMethods";
import { useParams } from "react-router";

const DataDiploms = () => {
  const { diploms } = useSelector((state: State) => state.diploms);
  const {
    showEditDiplom, setShowEditDiplom,
    showDeleteDiplom, setShowDeleteDiplom,
    setSelectedDiplom
  } = useContext(ShowDiplomsContext)

  const toggleEditDiplom = (diplom: DiplomInterface) => {
    setSelectedDiplom(diplom)
    setShowEditDiplom(!showEditDiplom)
  }

  const toggleDeleteDiplom = (diplom: DiplomInterface) => {
    setSelectedDiplom(diplom)
    setShowDeleteDiplom(!showDeleteDiplom)
  }

  const downloadImage = (imageUrl: any, name: string) => {
    fetch(imageUrl)
      .then(response => response.blob())
      .then(blob => {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement('a');
        link.href = url;
        const pathname = new URL(imageUrl).pathname;
        const fileExtension = pathname.split('.').pop();
        console.log(fileExtension); 
        link.download = name + "." + fileExtension;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    })
  }

  const { doctorId } = useParams()

  return (
    <div className="grid md:grid-cols-3 gap-2 mt-2">
      {diploms
      .filter((diplom: DiplomInterface) => diplom.doctor._id === doctorId)
      .map((diplom: DiplomInterface, index) => (
        <div className="bg-white rounded shadow-lg p-2" key={index}>
        <section className='grid grid-cols-2 my-4'>
          <div>
            <b>Titre: </b>  
            <span>{diplom.title}</span>   
          </div>
          <div>
            <b>Periode d'études: </b>  
            <span>{diplom.period}</span>   
          </div>
          <div>
            <b>Faculté: </b>  
            <span>{diplom.faculty}</span>   
          </div>
          <div>
            <b>Type: </b>  
            <span>{diplom.type}</span>   
          </div>
          <div className="col-span-2">
            <b>Nombre d'années d'études réussies: </b>  
            <span>{diplom.yearsOfSuccessfulStudy}</span>   
          </div>
          <div className="col-span-2">
            <b>Lieu d'obtention: </b>  
            <span>{diplom.placeOfGraduation}</span>   
          </div>
          <div className="col-span-2">
            <b>Date d'obtention: </b>  
            <span>{formatDate(diplom.dateOfGraduation)}</span>   
          </div>
        </section>
        {(diplom.image && (typeof diplom.image === 'string')) && <div className='flex justify-center items-center'>
          <img className='shadow-lg max-h-56' src={hostName + "imgs/diploms/" + diplom.image} alt="sss" /> 
        </div>}

        <div className="flex justify-center gap-2 mt-2">
          {diplom.image && 
            <FaDownload className="text-main text-2xl" onClick={() => downloadImage(hostName + "imgs/diploms/" + diplom.image, diplom.doctor?.fullName + "-" + diplom.title)}/>
          }
          <FaEdit className="text-second text-2xl" onClick={() => toggleEditDiplom(diplom)} />
          <MdRemoveCircle className="text-red text-2xl" onClick={() => toggleDeleteDiplom(diplom)} />
        </div>


        </div>
        
    ))}
    </div>    
  );
};

export default DataDiploms;



/*

  return (
    <div className="grid md:grid-cols-3">
      <div className="col-span-2 flex flex-col border">
        <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full sm:px-4 lg:px-8">
            <div className="overflow-hidden">
              <table className="min-w-full text-left text-sm font-light">
                <thead className="border-b font-medium bg-main text-white">
                  <tr>
                    <th className="px-4 py-4 border-r">Title</th>
                    <th className="px-4 py-4 border-r">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {diploms.map((diplom: DiplomInterface, index) => (
                    <tr className="border-b" key={index}>
                      <td className="whitespace-nowrap px-4 py-2 border-r bg-white font-medium">
                        {diplom.title}
                      </td>
                      <td className="whitespace-nowrap px-4 py-2 border-r bg-white font-medium">
                        <div className="flex justify-center gap-1">
                          <FaEye className="text-main text-2xl" onClick={() => toggleSelectedDiplom(diplom)} />
                          <FaEdit className="text-second text-2xl" onClick={() => toggleEditDiplom(diplom)} />
                          <MdRemoveCircle className="text-red text-2xl" onClick={() => toggleDeleteDiplom(diplom)} />
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>    
  );

*/